import { render } from "./SVGLogo-TPG.vue?vue&type=template&id=5fda4bda"
import script from "./SVGLogo-TPG.vue?vue&type=script&lang=js"
export * from "./SVGLogo-TPG.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/clientwebview/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__